import { render, staticRenderFns } from "./information-maintenance-list.vue?vue&type=template&id=4b50153e&scoped=true"
import script from "./information-maintenance-list.vue?vue&type=script&lang=ts"
export * from "./information-maintenance-list.vue?vue&type=script&lang=ts"
import style0 from "./information-maintenance-list.vue?vue&type=style&index=0&id=4b50153e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b50153e",
  null
  
)

export default component.exports